import { mapState } from 'vuex'

const tableMixin = {
  data () {
    return {
      tableSize1: '',
      lastName: '',
      // 表格纵向滚动高度：动态测量表格内容区顶部位置后计算，
      // 使横向滚动条固定显示在可视区底部，避免被撑到页面底部之外
      tableScrollY: 400
    }
  },
  computed: {
    ...mapState({
      tableBordered: state => state.app.tableBordered
    }),
    tableSize: {
      get () { return this.tableSize1 || this.$store.state.app.tableSize },
      set (value) {
        this.tableSize1 = value
      }
    }
  },
  mounted () {
    // 首次渲染及列表数据异步返回后各测量一次，避免依赖 updated 钩子造成的重复渲染
    this.$nextTick(() => this.$_tableMixin_updateScrollY())
    this.$_tableMixin_scrollYTimer = setTimeout(() => this.$_tableMixin_updateScrollY(), 600)
    this.$_tableMixin_onResize = () => {
      this.$_tableMixin_updateScrollY()
    }
    window.addEventListener('resize', this.$_tableMixin_onResize)
  },
  beforeDestroy () {
    if (this.$_tableMixin_onResize) {
      window.removeEventListener('resize', this.$_tableMixin_onResize)
    }
    if (this.$_tableMixin_scrollYTimer) {
      clearTimeout(this.$_tableMixin_scrollYTimer)
    }
  },
  methods: {
    // 根据表格内容区(.ant-table-body)在页面中的实际位置动态计算纵向滚动高度，
    // 预留底部空间给横向滚动条，保证其始终显示在可视区内
    $_tableMixin_updateScrollY () {
      if (typeof window === 'undefined' || !this.$el || !this.$el.querySelector) {
        return
      }
      const bodyEl = this.$el.querySelector('.ant-table-body')
      if (!bodyEl) {
        return
      }
      const top = bodyEl.getBoundingClientRect().top
      const bottomReserve = 32
      // 最小高度下限：保证表格至少显示约 3 行内容（部分列表行较高，含商品大图约 142px）
      const minHeight = 360
      const next = Math.max(minHeight, Math.round(window.innerHeight - top - bottomReserve))
      if (Math.abs(next - this.tableScrollY) > 1) {
        this.tableScrollY = next
      }
    },
    onShowSizeChange (current, pageSize) {
      if (!this.queryParam) {
        return
      }
      this.queryParam.pageSize = pageSize
      if (typeof this.getList === 'function') {
        this.getList()
      }
    },
    changeSize (current, pageSize) {
      if (!this.queryParam) {
        return
      }
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      if (typeof this.getList === 'function') {
        this.getList()
      }
    }
  }
}

export {
  tableMixin
}
